import React from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, HeartIcon, StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { productPrice, checkoutUrl } from '../data/bonuses';
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-cream" data-id="element-74" data-mp="9l34tdl96e4i">
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-blush/40" aria-hidden="true" data-id="element-75" data-mp="4mru70n4vzl8" />
      <div className="pointer-events-none absolute -left-32 top-1/2 h-80 w-80 rounded-full bg-sand" aria-hidden="true" data-id="element-76" data-mp="128yzydv6bxz6" />

      <div className="relative mx-auto grid w-full max-w-6xl gap-12 px-5 pb-16 pt-12 sm:px-8 md:pb-24 md:pt-16 lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:gap-16" data-id="element-77" data-mp="x8jmlmaw6qh7">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} data-id="element-78" data-mp="nbop96qcuw4i">
          <span className="inline-flex items-center gap-2 rounded-full border border-plum/15 bg-white/60 px-4 py-2 text-xs font-medium uppercase tracking-[0.22em] text-plum" data-id="element-79" data-mp="3825yir8x69lw">
            <HeartIcon className="h-3.5 w-3.5 text-clay" aria-hidden="true" data-id="element-80" data-mp="3o7c0y05rgtho" />
            eBook + 6 bonos gratis
          </span>

          <h1 className="mt-6 font-display text-4xl leading-[1.08] text-plum sm:text-5xl md:text-6xl" data-id="element-81" data-mp="399b9pjftv5tv">
            ¿Te perdiste un poco desde que empezaste a poner a todos{' '}
            <em className="not-italic text-clay" data-id="element-82" data-mp="30hhp9lx6haz0">antes que a ti</em>?
          </h1>

          <p className="mt-6 max-w-xl text-lg leading-relaxed text-ink/75" data-id="element-83" data-mp="358re4kawka9u">
No estas cansada de hacer demasiado. Porque cada vez que eliges a todos antes que a ti, te vas apagando un poco más. Y sin darte cuenta, llega un día en el que ya no sabes cuándo fue la última vez que te sentiste realmente bien.
          </p>

          <p className="mt-4 max-w-xl font-display text-2xl italic leading-snug text-plum" data-id="element-84" data-mp="2hinc2hdd4iky">
            «Me Elijo» es el camino de vuelta a ti.
          </p>

          <div className="mt-9" data-id="element-85" data-mp="2lmuyu909fogj">
            <CtaButton label={`QUIERO EMPEZAR HOY — ${productPrice}`} href={checkoutUrl} sublabel="Descarga inmediata · Pago seguro · Sin envíos ni esperas" data-id="element-86" data-mp="s2jmbumnjwig" />
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-x-7 gap-y-3 text-sm text-ink/65" data-id="element-87" data-mp="id03goyxw2nl">
            <span className="inline-flex items-center gap-2" data-id="element-88" data-mp="degfkj0scgsl">
              <span className="flex" aria-hidden="true" data-id="element-89" data-mp="1b0nhtm9m9x1s">
                {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-clay text-clay" data-id="element-90" data-mp="161ay3ae1l63f" />)}
              </span>
              +7000mujeres ya empezaron
            </span>
            <span className="inline-flex items-center gap-2" data-id="element-91" data-mp="114kjkrhvyik4">
              <DownloadIcon className="h-4 w-4 text-clay" aria-hidden="true" data-id="element-92" data-mp="x0l50eg61tte" />
              Acceso en menos de 2 minutos
            </span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.15,
        ease: 'easeOut'
      }} className="relative" data-id="element-93" data-mp="3hr3qlsftw548">
          <img src="https://cdn.shopify.com/s/files/1/0825/1706/5986/files/ChatGPT_Image_21_jun_2026_12_32_36_a.m..png?v=1782091497" alt="eBook Me Elijo mostrado en tablet y en versión impresa" className="w-full rounded-[2rem] object-cover shadow-soft" loading="eager" data-id="element-94" data-mp="21bftfk4bp5rt" />
          <div className="absolute -bottom-5 left-4 rounded-2xl bg-plum px-5 py-4 text-cream shadow-soft sm:left-8" data-id="element-95" data-mp="2g257cu964yzd">
            <p className="text-[0.7rem] uppercase tracking-[0.22em] text-blush" data-id="element-96" data-mp="2p0qnyjv2y3xi">Hoy incluye</p>
            <p className="font-display text-2xl leading-tight" data-id="element-97" data-mp="2tzlj8la8hkyi">6 bonos gratis</p>
          </div>
        </motion.div>
      </div>
    </header>;
}